export const CONTRACT = `CONTRACT`;

export const GET_ALL_DOCUMENT_TYPES_DATA = `${CONTRACT}/GET_ALL_DOCUMENT_TYPES_DATA`;
export const SET_ALL_DOCUMENT_TYPES_DATA = `${CONTRACT}/SET_ALL_DOCUMENT_TYPES_DATA`;

export const GET_FIND_UPLOAD_DOCUMENT_HISTORY_DATA = `${CONTRACT}/GET_FIND_UPLOAD_DOCUMENT_HISTORY_DATA`;
export const SET_FIND_UPLOAD_DOCUMENT_HISTORY_DATA = `${CONTRACT}/SET_FIND_UPLOAD_DOCUMENT_HISTORY_DATA`;

export const SET_FILTER_FIND_UPLOAD_DOCUMENT_HISTORY_CONFIG = `${CONTRACT}/SET_FILTER_FIND_UPLOAD_DOCUMENT_HISTORY_CONFIG`;
